export const COOKBOOK_CHAPTERS = [
  "Rice & congee",
  "Noodles",
  "Dumplings & wontons",
  "Buns & breads",
  "Dim sum & street food",
  "Cold dishes",
  "Pork",
  "Beef & lamb",
  "Poultry",
  "Fish",
  "Seafood",
  "Tofu & eggs",
  "Vegetables",
  "Soups",
  "Hot pot & dry pot",
  "Desserts",
] as const;

export interface CookbookRecipe {
  chapter: (typeof COOKBOOK_CHAPTERS)[number];
  english: string;
  id: string;
  simplified: string;
  traditional: string;
}

/** Complete unlockable catalog; IDs remain stable as the book grows. */
export const COOKBOOK_RECIPES: readonly CookbookRecipe[] = [
  {
    chapter: "Rice & congee",
    english: "Egg fried rice",
    id: "egg-fried-rice",
    simplified: "蛋炒饭",
    traditional: "蛋炒飯",
  },
  {
    chapter: "Rice & congee",
    english: "Yangzhou fried rice",
    id: "yangzhou-fried-rice",
    simplified: "扬州炒饭",
    traditional: "揚州炒飯",
  },
  {
    chapter: "Rice & congee",
    english: "Shrimp fried rice",
    id: "shrimp-fried-rice",
    simplified: "虾仁炒饭",
    traditional: "蝦仁炒飯",
  },
  {
    chapter: "Rice & congee",
    english: "Beef fried rice",
    id: "beef-fried-rice",
    simplified: "牛肉炒饭",
    traditional: "牛肉炒飯",
  },
  {
    chapter: "Rice & congee",
    english: "Chicken fried rice",
    id: "chicken-fried-rice",
    simplified: "鸡肉炒饭",
    traditional: "雞肉炒飯",
  },
  {
    chapter: "Rice & congee",
    english: "Char siu fried rice",
    id: "char-siu-fried-rice",
    simplified: "叉烧炒饭",
    traditional: "叉燒炒飯",
  },
  {
    chapter: "Rice & congee",
    english: "Salted fish and chicken fried rice",
    id: "salted-fish-and-chicken-fried-rice",
    simplified: "咸鱼鸡粒炒饭",
    traditional: "鹹魚雞粒炒飯",
  },
  {
    chapter: "Rice & congee",
    english: "Pineapple fried rice",
    id: "pineapple-fried-rice",
    simplified: "菠萝炒饭",
    traditional: "菠蘿炒飯",
  },
  {
    chapter: "Rice & congee",
    english: "Soy sauce fried rice",
    id: "soy-sauce-fried-rice",
    simplified: "酱油炒饭",
    traditional: "醬油炒飯",
  },
  {
    chapter: "Rice & congee",
    english: "Claypot rice with cured meats",
    id: "claypot-rice-with-cured-meats",
    simplified: "腊味煲仔饭",
    traditional: "臘味煲仔飯",
  },
  {
    chapter: "Rice & congee",
    english: "Claypot rice with pork ribs",
    id: "claypot-rice-with-pork-ribs",
    simplified: "排骨煲仔饭",
    traditional: "排骨煲仔飯",
  },
  {
    chapter: "Rice & congee",
    english: "Claypot rice with chicken and mushrooms",
    id: "claypot-rice-with-chicken-and-mushrooms",
    simplified: "香菇滑鸡煲仔饭",
    traditional: "香菇滑雞煲仔飯",
  },
  {
    chapter: "Rice & congee",
    english: "Braised minced pork rice",
    id: "braised-minced-pork-rice",
    simplified: "卤肉饭",
    traditional: "滷肉飯",
  },
  {
    chapter: "Rice & congee",
    english: "Shredded chicken rice",
    id: "shredded-chicken-rice",
    simplified: "鸡肉饭",
    traditional: "雞肉飯",
  },
  {
    chapter: "Rice & congee",
    english: "Lard rice",
    id: "lard-rice",
    simplified: "猪油拌饭",
    traditional: "豬油拌飯",
  },
  {
    chapter: "Rice & congee",
    english: "Eight-treasure rice",
    id: "eight-treasure-rice",
    simplified: "八宝饭",
    traditional: "八寶飯",
  },
  {
    chapter: "Rice & congee",
    english: "Lotus-leaf rice",
    id: "lotus-leaf-rice",
    simplified: "荷叶饭",
    traditional: "荷葉飯",
  },
  {
    chapter: "Rice & congee",
    english: "Bamboo-tube rice",
    id: "bamboo-tube-rice",
    simplified: "竹筒饭",
    traditional: "竹筒飯",
  },
  {
    chapter: "Rice & congee",
    english: "Rice congee",
    id: "congee",
    simplified: "白粥",
    traditional: "白粥",
  },
  {
    chapter: "Rice & congee",
    english: "Century egg and pork congee",
    id: "century-egg-and-pork-congee",
    simplified: "皮蛋瘦肉粥",
    traditional: "皮蛋瘦肉粥",
  },
  {
    chapter: "Rice & congee",
    english: "Fish congee",
    id: "fish-congee",
    simplified: "鱼片粥",
    traditional: "魚片粥",
  },
  {
    chapter: "Rice & congee",
    english: "Sampan congee",
    id: "sampan-congee",
    simplified: "艇仔粥",
    traditional: "艇仔粥",
  },
  {
    chapter: "Rice & congee",
    english: "Pork offal congee",
    id: "pork-offal-congee",
    simplified: "及第粥",
    traditional: "及第粥",
  },
  {
    chapter: "Rice & congee",
    english: "Pumpkin congee",
    id: "pumpkin-congee",
    simplified: "南瓜粥",
    traditional: "南瓜粥",
  },
  {
    chapter: "Rice & congee",
    english: "Millet congee",
    id: "millet-congee",
    simplified: "小米粥",
    traditional: "小米粥",
  },
  {
    chapter: "Noodles",
    english: "Beef noodle soup",
    id: "beef-noodle-soup",
    simplified: "牛肉面",
    traditional: "牛肉麵",
  },
  {
    chapter: "Noodles",
    english: "Dan dan noodles",
    id: "dan-dan-noodles",
    simplified: "担担面",
    traditional: "擔擔麵",
  },
  {
    chapter: "Noodles",
    english: "Chow mein",
    id: "chow-mein",
    simplified: "炒面",
    traditional: "炒麵",
  },
  {
    chapter: "Noodles",
    english: "Zhajiang noodles",
    id: "zhajiang-noodles",
    simplified: "炸酱面",
    traditional: "炸醬麵",
  },
  {
    chapter: "Noodles",
    english: "Hot dry noodles",
    id: "hot-dry-noodles",
    simplified: "热干面",
    traditional: "熱乾麵",
  },
  {
    chapter: "Noodles",
    english: "Hot oil noodles",
    id: "hot-oil-noodles",
    simplified: "油泼面",
    traditional: "油潑麵",
  },
  {
    chapter: "Noodles",
    english: "Scallion oil noodles",
    id: "scallion-oil-noodles",
    simplified: "葱油拌面",
    traditional: "蔥油拌麵",
  },
  {
    chapter: "Noodles",
    english: "Chongqing noodles",
    id: "chongqing-noodles",
    simplified: "重庆小面",
    traditional: "重慶小麵",
  },
  {
    chapter: "Noodles",
    english: "Lanzhou hand-pulled noodles",
    id: "lanzhou-hand-pulled-noodles",
    simplified: "兰州拉面",
    traditional: "蘭州拉麵",
  },
  {
    chapter: "Noodles",
    english: "Knife-cut noodles",
    id: "knife-cut-noodles",
    simplified: "刀削面",
    traditional: "刀削麵",
  },
  {
    chapter: "Noodles",
    english: "Saozi noodles",
    id: "saozi-noodles",
    simplified: "臊子面",
    traditional: "臊子麵",
  },
  {
    chapter: "Noodles",
    english: "Braised noodles",
    id: "braised-noodles",
    simplified: "焖面",
    traditional: "燜麵",
  },
  {
    chapter: "Noodles",
    english: "Henan braised noodles",
    id: "henan-braised-noodles",
    simplified: "烩面",
    traditional: "燴麵",
  },
  {
    chapter: "Noodles",
    english: "Hangzhou pork and pickled vegetable noodles",
    id: "hangzhou-pork-and-pickled-vegetable-noodles",
    simplified: "片儿川",
    traditional: "片兒川",
  },
  {
    chapter: "Noodles",
    english: "Yangchun noodle soup",
    id: "yangchun-noodle-soup",
    simplified: "阳春面",
    traditional: "陽春麵",
  },
  {
    chapter: "Noodles",
    english: "Wonton noodles",
    id: "wonton-noodles",
    simplified: "云吞面",
    traditional: "雲吞麵",
  },
  {
    chapter: "Noodles",
    english: "Bamboo-pressed noodles",
    id: "bamboo-pressed-noodles",
    simplified: "竹升面",
    traditional: "竹升面",
  },
  {
    chapter: "Noodles",
    english: "Dry-fried beef chow fun",
    id: "dry-fried-beef-chow-fun",
    simplified: "干炒牛河",
    traditional: "乾炒牛河",
  },
  {
    chapter: "Noodles",
    english: "Singapore-style rice noodles",
    id: "singapore-style-rice-noodles",
    simplified: "星洲炒米粉",
    traditional: "星洲炒米粉",
  },
  {
    chapter: "Noodles",
    english: "Crossing-the-bridge rice noodles",
    id: "crossing-the-bridge-rice-noodles",
    simplified: "过桥米线",
    traditional: "過橋米線",
  },
  {
    chapter: "Noodles",
    english: "Liuzhou snail rice noodles",
    id: "liuzhou-snail-rice-noodles",
    simplified: "螺蛳粉",
    traditional: "螺螄粉",
  },
  {
    chapter: "Noodles",
    english: "Guilin rice noodles",
    id: "guilin-rice-noodles",
    simplified: "桂林米粉",
    traditional: "桂林米粉",
  },
  {
    chapter: "Noodles",
    english: "Hot and sour glass noodles",
    id: "hot-and-sour-glass-noodles",
    simplified: "酸辣粉",
    traditional: "酸辣粉",
  },
  {
    chapter: "Noodles",
    english: "Glass noodles with minced pork",
    id: "glass-noodles-with-minced-pork",
    simplified: "蚂蚁上树",
    traditional: "螞蟻上樹",
  },
  {
    chapter: "Noodles",
    english: "Pork intestine vermicelli",
    id: "pork-intestine-vermicelli",
    simplified: "大肠面线",
    traditional: "大腸麵線",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Dumplings",
    id: "dumplings",
    simplified: "饺子",
    traditional: "餃子",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Soup dumplings",
    id: "soup-dumplings",
    simplified: "小笼包",
    traditional: "小籠包",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Wontons",
    id: "wontons",
    simplified: "馄饨",
    traditional: "餛飩",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Potstickers",
    id: "potstickers",
    simplified: "锅贴",
    traditional: "鍋貼",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Pork and chive dumplings",
    id: "pork-and-chive-dumplings",
    simplified: "韭菜猪肉饺",
    traditional: "韭菜豬肉餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Pork and cabbage dumplings",
    id: "pork-and-cabbage-dumplings",
    simplified: "白菜猪肉饺",
    traditional: "白菜豬肉餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Pork and celery dumplings",
    id: "pork-and-celery-dumplings",
    simplified: "芹菜猪肉饺",
    traditional: "芹菜豬肉餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Pork and pickled cabbage dumplings",
    id: "pork-and-pickled-cabbage-dumplings",
    simplified: "酸菜猪肉饺",
    traditional: "酸菜豬肉餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Beef dumplings",
    id: "beef-dumplings",
    simplified: "牛肉水饺",
    traditional: "牛肉水餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Lamb dumplings",
    id: "lamb-dumplings",
    simplified: "羊肉水饺",
    traditional: "羊肉水餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Shrimp dumplings",
    id: "shrimp-dumplings",
    simplified: "虾仁水饺",
    traditional: "蝦仁水餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Chive and egg dumplings",
    id: "chive-and-egg-dumplings",
    simplified: "韭菜鸡蛋饺",
    traditional: "韭菜雞蛋餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Three-delicacy dumplings",
    id: "three-delicacy-dumplings",
    simplified: "三鲜水饺",
    traditional: "三鮮水餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Mackerel dumplings",
    id: "mackerel-dumplings",
    simplified: "鲅鱼水饺",
    traditional: "鮁魚水餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Mushroom vegetable dumplings",
    id: "mushroom-vegetable-dumplings",
    simplified: "香菇素饺",
    traditional: "香菇素餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Steamed dumplings",
    id: "steamed-dumplings",
    simplified: "蒸饺",
    traditional: "蒸餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Pan-fried dumplings",
    id: "pan-fried-dumplings",
    simplified: "煎饺",
    traditional: "煎餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Dumplings in sour soup",
    id: "dumplings-in-sour-soup",
    simplified: "酸汤水饺",
    traditional: "酸湯水餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Zhong dumplings in chili sauce",
    id: "zhong-dumplings-in-chili-sauce",
    simplified: "钟水饺",
    traditional: "鍾水餃",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Wontons in chili oil",
    id: "wontons-in-chili-oil",
    simplified: "红油抄手",
    traditional: "紅油抄手",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Shrimp wontons",
    id: "shrimp-wontons",
    simplified: "鲜虾云吞",
    traditional: "鮮蝦雲吞",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Shepherd's purse wontons",
    id: "shepherd-s-purse-wontons",
    simplified: "荠菜馄饨",
    traditional: "薺菜餛飩",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Wontons in chicken broth",
    id: "wontons-in-chicken-broth",
    simplified: "鸡汤馄饨",
    traditional: "雞湯餛飩",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Crab roe soup dumplings",
    id: "crab-roe-soup-dumplings",
    simplified: "蟹粉小笼包",
    traditional: "蟹粉小籠包",
  },
  {
    chapter: "Dumplings & wontons",
    english: "Broth-filled dumplings",
    id: "broth-filled-dumplings",
    simplified: "灌汤饺",
    traditional: "灌湯餃",
  },
  {
    chapter: "Buns & breads",
    english: "Steamed buns",
    id: "steamed-buns",
    simplified: "包子",
    traditional: "包子",
  },
  {
    chapter: "Buns & breads",
    english: "Barbecue pork buns",
    id: "barbecue-pork-buns",
    simplified: "叉烧包",
    traditional: "叉燒包",
  },
  {
    chapter: "Buns & breads",
    english: "Pan-fried pork buns",
    id: "pan-fried-pork-buns",
    simplified: "生煎包",
    traditional: "生煎包",
  },
  {
    chapter: "Buns & breads",
    english: "Shredded radish buns",
    id: "shredded-radish-buns",
    simplified: "萝卜丝包",
    traditional: "蘿蔔絲包",
  },
  {
    chapter: "Buns & breads",
    english: "Fresh pork buns",
    id: "fresh-pork-buns",
    simplified: "鲜肉包",
    traditional: "鮮肉包",
  },
  {
    chapter: "Buns & breads",
    english: "Mushroom and vegetable buns",
    id: "mushroom-and-vegetable-buns",
    simplified: "香菇菜包",
    traditional: "香菇菜包",
  },
  {
    chapter: "Buns & breads",
    english: "Red bean buns",
    id: "red-bean-buns",
    simplified: "豆沙包",
    traditional: "豆沙包",
  },
  {
    chapter: "Buns & breads",
    english: "Custard buns",
    id: "custard-buns",
    simplified: "奶黄包",
    traditional: "奶黃包",
  },
  {
    chapter: "Buns & breads",
    english: "Salted egg custard buns",
    id: "salted-egg-custard-buns",
    simplified: "流沙包",
    traditional: "流沙包",
  },
  {
    chapter: "Buns & breads",
    english: "Lotus seed paste buns",
    id: "lotus-seed-paste-buns",
    simplified: "莲蓉包",
    traditional: "蓮蓉包",
  },
  {
    chapter: "Buns & breads",
    english: "Preserved mustard green buns",
    id: "preserved-mustard-green-buns",
    simplified: "梅干菜包",
    traditional: "梅乾菜包",
  },
  {
    chapter: "Buns & breads",
    english: "Water-fried buns",
    id: "water-fried-buns",
    simplified: "水煎包",
    traditional: "水煎包",
  },
  {
    chapter: "Buns & breads",
    english: "Shandong large buns",
    id: "shandong-large-buns",
    simplified: "山东大包",
    traditional: "山東大包",
  },
  {
    chapter: "Buns & breads",
    english: "Plain steamed bread",
    id: "plain-steamed-bread",
    simplified: "馒头",
    traditional: "饅頭",
  },
  {
    chapter: "Buns & breads",
    english: "Twisted steamed rolls",
    id: "twisted-steamed-rolls",
    simplified: "花卷",
    traditional: "花捲",
  },
  {
    chapter: "Buns & breads",
    english: "Cornmeal steamed buns",
    id: "cornmeal-steamed-buns",
    simplified: "窝窝头",
    traditional: "窩窩頭",
  },
  {
    chapter: "Buns & breads",
    english: "Corn cakes",
    id: "corn-cakes",
    simplified: "玉米饼",
    traditional: "玉米餅",
  },
  {
    chapter: "Buns & breads",
    english: "Sesame flatbread",
    id: "sesame-flatbread",
    simplified: "烧饼",
    traditional: "燒餅",
  },
  {
    chapter: "Buns & breads",
    english: "Scallion pancakes",
    id: "scallion-pancakes",
    simplified: "葱油饼",
    traditional: "蔥油餅",
  },
  {
    chapter: "Buns & breads",
    english: "Chive pockets",
    id: "chive-pockets",
    simplified: "韭菜盒子",
    traditional: "韭菜盒子",
  },
  {
    chapter: "Buns & breads",
    english: "Shaanxi pork sandwich",
    id: "shaanxi-pork-sandwich",
    simplified: "肉夹馍",
    traditional: "肉夾饃",
  },
  {
    chapter: "Buns & breads",
    english: "Tongguan crispy pork sandwich",
    id: "tongguan-crispy-pork-sandwich",
    simplified: "潼关肉夹馍",
    traditional: "潼關肉夾饃",
  },
  {
    chapter: "Buns & breads",
    english: "Guokui flatbread",
    id: "guokui-flatbread",
    simplified: "锅盔",
    traditional: "鍋盔",
  },
  {
    chapter: "Buns & breads",
    english: "Uyghur naan",
    id: "uyghur-naan",
    simplified: "馕",
    traditional: "饢",
  },
  {
    chapter: "Buns & breads",
    english: "Spring pancakes",
    id: "spring-pancakes",
    simplified: "春饼",
    traditional: "春餅",
  },
  {
    chapter: "Dim sum & street food",
    english: "Har gow shrimp dumplings",
    id: "har-gow-shrimp-dumplings",
    simplified: "虾饺",
    traditional: "蝦餃",
  },
  {
    chapter: "Dim sum & street food",
    english: "Siu mai",
    id: "siu-mai",
    simplified: "烧卖",
    traditional: "燒賣",
  },
  {
    chapter: "Dim sum & street food",
    english: "Sticky rice shumai",
    id: "sticky-rice-shumai",
    simplified: "糯米烧卖",
    traditional: "糯米燒賣",
  },
  {
    chapter: "Dim sum & street food",
    english: "Lotus-leaf sticky rice chicken",
    id: "lotus-leaf-sticky-rice-chicken",
    simplified: "糯米鸡",
    traditional: "糯米雞",
  },
  {
    chapter: "Dim sum & street food",
    english: "Turnip cakes",
    id: "turnip-cakes",
    simplified: "萝卜糕",
    traditional: "蘿蔔糕",
  },
  {
    chapter: "Dim sum & street food",
    english: "Taro cakes",
    id: "taro-cakes",
    simplified: "芋头糕",
    traditional: "芋頭糕",
  },
  {
    chapter: "Dim sum & street food",
    english: "Water chestnut cakes",
    id: "water-chestnut-cakes",
    simplified: "马蹄糕",
    traditional: "馬蹄糕",
  },
  {
    chapter: "Dim sum & street food",
    english: "Rice noodle rolls",
    id: "rice-noodle-rolls",
    simplified: "肠粉",
    traditional: "腸粉",
  },
  {
    chapter: "Dim sum & street food",
    english: "Shrimp rice noodle rolls",
    id: "shrimp-rice-noodle-rolls",
    simplified: "鲜虾肠粉",
    traditional: "鮮蝦腸粉",
  },
  {
    chapter: "Dim sum & street food",
    english: "Beef rice noodle rolls",
    id: "beef-rice-noodle-rolls",
    simplified: "牛肉肠粉",
    traditional: "牛肉腸粉",
  },
  {
    chapter: "Dim sum & street food",
    english: "Barbecue pork rice noodle rolls",
    id: "barbecue-pork-rice-noodle-rolls",
    simplified: "叉烧肠粉",
    traditional: "叉燒腸粉",
  },
  {
    chapter: "Dim sum & street food",
    english: "Fried dough rice noodle rolls",
    id: "fried-dough-rice-noodle-rolls",
    simplified: "炸两",
    traditional: "炸兩",
  },
  {
    chapter: "Dim sum & street food",
    english: "Fried glutinous rice dumplings",
    id: "fried-glutinous-rice-dumplings",
    simplified: "咸水角",
    traditional: "鹹水角",
  },
  {
    chapter: "Dim sum & street food",
    english: "Crispy taro puffs",
    id: "crispy-taro-puffs",
    simplified: "炸芋角",
    traditional: "炸芋角",
  },
  {
    chapter: "Dim sum & street food",
    english: "Bean curd skin rolls",
    id: "bean-curd-skin-rolls",
    simplified: "腐皮卷",
    traditional: "腐皮卷",
  },
  {
    chapter: "Dim sum & street food",
    english: "Barbecue pork pastries",
    id: "barbecue-pork-pastries",
    simplified: "叉烧酥",
    traditional: "叉燒酥",
  },
  {
    chapter: "Dim sum & street food",
    english: "Spring rolls",
    id: "spring-rolls",
    simplified: "春卷",
    traditional: "春捲",
  },
  {
    chapter: "Dim sum & street food",
    english: "Fried dough sticks",
    id: "fried-dough-sticks",
    simplified: "油条",
    traditional: "油條",
  },
  {
    chapter: "Dim sum & street food",
    english: "Jianbing breakfast crepes",
    id: "jianbing-breakfast-crepes",
    simplified: "煎饼果子",
    traditional: "煎餅果子",
  },
  {
    chapter: "Dim sum & street food",
    english: "Egg-filled pancakes",
    id: "egg-filled-pancakes",
    simplified: "鸡蛋灌饼",
    traditional: "雞蛋灌餅",
  },
  {
    chapter: "Dim sum & street food",
    english: "Flaky hand-pulled pancakes",
    id: "flaky-hand-pulled-pancakes",
    simplified: "手抓饼",
    traditional: "手抓餅",
  },
  {
    chapter: "Dim sum & street food",
    english: "Griddled noodle sheets",
    id: "griddled-noodle-sheets",
    simplified: "烤冷面",
    traditional: "烤冷麵",
  },
  {
    chapter: "Dim sum & street food",
    english: "Stinky tofu",
    id: "stinky-tofu",
    simplified: "臭豆腐",
    traditional: "臭豆腐",
  },
  {
    chapter: "Dim sum & street food",
    english: "Oyster omelet",
    id: "oyster-omelet",
    simplified: "蚵仔煎",
    traditional: "蚵仔煎",
  },
  {
    chapter: "Dim sum & street food",
    english: "Taiwanese popcorn chicken",
    id: "taiwanese-popcorn-chicken",
    simplified: "盐酥鸡",
    traditional: "鹽酥雞",
  },
  {
    chapter: "Cold dishes",
    english: "Smashed cucumber salad",
    id: "smashed-cucumber-salad",
    simplified: "拍黄瓜",
    traditional: "拍黃瓜",
  },
  {
    chapter: "Cold dishes",
    english: "Wood ear mushroom salad",
    id: "wood-ear-mushroom-salad",
    simplified: "凉拌木耳",
    traditional: "涼拌木耳",
  },
  {
    chapter: "Cold dishes",
    english: "Shredded kelp salad",
    id: "shredded-kelp-salad",
    simplified: "凉拌海带丝",
    traditional: "涼拌海帶絲",
  },
  {
    chapter: "Cold dishes",
    english: "Three-shred salad",
    id: "three-shred-salad",
    simplified: "凉拌三丝",
    traditional: "涼拌三絲",
  },
  {
    chapter: "Cold dishes",
    english: "Shredded potato salad",
    id: "shredded-potato-salad",
    simplified: "凉拌土豆丝",
    traditional: "涼拌土豆絲",
  },
  {
    chapter: "Cold dishes",
    english: "Lotus root salad",
    id: "lotus-root-salad",
    simplified: "凉拌藕片",
    traditional: "涼拌藕片",
  },
  {
    chapter: "Cold dishes",
    english: "Shredded tofu salad",
    id: "shredded-tofu-salad",
    simplified: "凉拌豆腐丝",
    traditional: "涼拌豆腐絲",
  },
  {
    chapter: "Cold dishes",
    english: "Bean curd stick salad",
    id: "bean-curd-stick-salad",
    simplified: "凉拌腐竹",
    traditional: "涼拌腐竹",
  },
  {
    chapter: "Cold dishes",
    english: "Spinach salad",
    id: "spinach-salad",
    simplified: "凉拌菠菜",
    traditional: "涼拌菠菜",
  },
  {
    chapter: "Cold dishes",
    english: "Tiger salad",
    id: "tiger-salad",
    simplified: "老虎菜",
    traditional: "老虎菜",
  },
  {
    chapter: "Cold dishes",
    english: "Mixed vegetable salad",
    id: "mixed-vegetable-salad",
    simplified: "大拌菜",
    traditional: "大拌菜",
  },
  {
    chapter: "Cold dishes",
    english: "Sichuan pickled vegetables",
    id: "sichuan-pickled-vegetables",
    simplified: "四川泡菜",
    traditional: "四川泡菜",
  },
  {
    chapter: "Cold dishes",
    english: "Sweet pickled garlic",
    id: "sweet-pickled-garlic",
    simplified: "糖蒜",
    traditional: "糖蒜",
  },
  {
    chapter: "Cold dishes",
    english: "Pickled radish",
    id: "pickled-radish",
    simplified: "腌萝卜",
    traditional: "醃蘿蔔",
  },
  {
    chapter: "Cold dishes",
    english: "Sichuan sliced beef and offal",
    id: "sichuan-sliced-beef-and-offal",
    simplified: "夫妻肺片",
    traditional: "夫妻肺片",
  },
  {
    chapter: "Cold dishes",
    english: "Chicken in chili sauce",
    id: "chicken-in-chili-sauce",
    simplified: "口水鸡",
    traditional: "口水雞",
  },
  {
    chapter: "Cold dishes",
    english: "Bang bang chicken",
    id: "bang-bang-chicken",
    simplified: "棒棒鸡",
    traditional: "棒棒雞",
  },
  {
    chapter: "Cold dishes",
    english: "Pork slices with garlic sauce",
    id: "pork-slices-with-garlic-sauce",
    simplified: "蒜泥白肉",
    traditional: "蒜泥白肉",
  },
  {
    chapter: "Cold dishes",
    english: "Soy-braised beef slices",
    id: "soy-braised-beef-slices",
    simplified: "酱牛肉",
    traditional: "醬牛肉",
  },
  {
    chapter: "Cold dishes",
    english: "Pork rind jelly",
    id: "pork-rind-jelly",
    simplified: "猪皮冻",
    traditional: "豬皮凍",
  },
  {
    chapter: "Cold dishes",
    english: "Zhenjiang pork aspic",
    id: "zhenjiang-pork-aspic",
    simplified: "水晶肴肉",
    traditional: "水晶餚肉",
  },
  {
    chapter: "Cold dishes",
    english: "Jellyfish salad",
    id: "jellyfish-salad",
    simplified: "凉拌海蜇",
    traditional: "涼拌海蜇",
  },
  {
    chapter: "Cold dishes",
    english: "Drunken shrimp",
    id: "drunken-shrimp",
    simplified: "醉虾",
    traditional: "醉蝦",
  },
  {
    chapter: "Cold dishes",
    english: "Five-spice peanuts",
    id: "five-spice-peanuts",
    simplified: "五香花生",
    traditional: "五香花生",
  },
  {
    chapter: "Cold dishes",
    english: "Century egg tofu",
    id: "century-egg-tofu",
    simplified: "皮蛋豆腐",
    traditional: "皮蛋豆腐",
  },
  {
    chapter: "Pork",
    english: "Red-braised pork",
    id: "braised-pork",
    simplified: "红烧肉",
    traditional: "紅燒肉",
  },
  {
    chapter: "Pork",
    english: "Dongpo pork",
    id: "dongpo-pork",
    simplified: "东坡肉",
    traditional: "東坡肉",
  },
  {
    chapter: "Pork",
    english: "Twice-cooked pork",
    id: "twice-cooked-pork",
    simplified: "回锅肉",
    traditional: "回鍋肉",
  },
  {
    chapter: "Pork",
    english: "Pork slivers in garlic sauce",
    id: "pork-slivers-in-garlic-sauce",
    simplified: "鱼香肉丝",
    traditional: "魚香肉絲",
  },
  {
    chapter: "Pork",
    english: "Pork slivers in sweet bean sauce",
    id: "pork-slivers-in-sweet-bean-sauce",
    simplified: "京酱肉丝",
    traditional: "京醬肉絲",
  },
  {
    chapter: "Pork",
    english: "Sweet and sour pork tenderloin",
    id: "sweet-and-sour-pork-tenderloin",
    simplified: "糖醋里脊",
    traditional: "糖醋里脊",
  },
  {
    chapter: "Pork",
    english: "Cantonese sweet and sour pork",
    id: "cantonese-sweet-and-sour-pork",
    simplified: "咕噜肉",
    traditional: "咕嚕肉",
  },
  {
    chapter: "Pork",
    english: "Northeastern crispy sweet and sour pork",
    id: "northeastern-crispy-sweet-and-sour-pork",
    simplified: "锅包肉",
    traditional: "鍋包肉",
  },
  {
    chapter: "Pork",
    english: "Moo shu pork",
    id: "moo-shu-pork",
    simplified: "木须肉",
    traditional: "木須肉",
  },
  {
    chapter: "Pork",
    english: "Hunan pork and pepper stir-fry",
    id: "hunan-pork-and-pepper-stir-fry",
    simplified: "农家小炒肉",
    traditional: "農家小炒肉",
  },
  {
    chapter: "Pork",
    english: "Pork belly with preserved mustard greens",
    id: "pork-belly-with-preserved-mustard-greens",
    simplified: "梅菜扣肉",
    traditional: "梅菜扣肉",
  },
  {
    chapter: "Pork",
    english: "Rice-flour steamed pork",
    id: "rice-flour-steamed-pork",
    simplified: "粉蒸肉",
    traditional: "粉蒸肉",
  },
  {
    chapter: "Pork",
    english: "Garlic pork ribs",
    id: "garlic-pork-ribs",
    simplified: "蒜香排骨",
    traditional: "蒜香排骨",
  },
  {
    chapter: "Pork",
    english: "Sweet and sour ribs",
    id: "sweet-and-sour-ribs",
    simplified: "糖醋排骨",
    traditional: "糖醋排骨",
  },
  {
    chapter: "Pork",
    english: "Braised pork ribs",
    id: "braised-pork-ribs",
    simplified: "红烧排骨",
    traditional: "紅燒排骨",
  },
  {
    chapter: "Pork",
    english: "Steamed ribs in black bean sauce",
    id: "steamed-ribs-in-black-bean-sauce",
    simplified: "豉汁蒸排骨",
    traditional: "豉汁蒸排骨",
  },
  {
    chapter: "Pork",
    english: "Salt and pepper ribs",
    id: "salt-and-pepper-ribs",
    simplified: "椒盐排骨",
    traditional: "椒鹽排骨",
  },
  {
    chapter: "Pork",
    english: "Wuxi braised ribs",
    id: "wuxi-braised-ribs",
    simplified: "无锡酱排骨",
    traditional: "無錫醬排骨",
  },
  {
    chapter: "Pork",
    english: "Lion's head meatballs",
    id: "lion-s-head-meatballs",
    simplified: "狮子头",
    traditional: "獅子頭",
  },
  {
    chapter: "Pork",
    english: "Four-joy meatballs",
    id: "four-joy-meatballs",
    simplified: "四喜丸子",
    traditional: "四喜丸子",
  },
  {
    chapter: "Pork",
    english: "Cantonese barbecue pork",
    id: "cantonese-barbecue-pork",
    simplified: "叉烧",
    traditional: "叉燒",
  },
  {
    chapter: "Pork",
    english: "Crispy roast pork belly",
    id: "crispy-roast-pork-belly",
    simplified: "脆皮烧肉",
    traditional: "脆皮燒肉",
  },
  {
    chapter: "Pork",
    english: "Braised pig's trotters",
    id: "braised-pig-s-trotters",
    simplified: "红烧猪蹄",
    traditional: "紅燒豬蹄",
  },
  {
    chapter: "Pork",
    english: "Shandong braised pork intestines",
    id: "shandong-braised-pork-intestines",
    simplified: "九转大肠",
    traditional: "九轉大腸",
  },
  {
    chapter: "Pork",
    english: "Stir-fried pork liver",
    id: "stir-fried-pork-liver",
    simplified: "溜肝尖",
    traditional: "溜肝尖",
  },
  {
    chapter: "Beef & lamb",
    english: "Sichuan chili-poached beef",
    id: "sichuan-chili-poached-beef",
    simplified: "水煮牛肉",
    traditional: "水煮牛肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Hunan yellow beef stir-fry",
    id: "hunan-yellow-beef-stir-fry",
    simplified: "小炒黄牛肉",
    traditional: "小炒黃牛肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Black pepper beef",
    id: "black-pepper-beef",
    simplified: "黑椒牛柳",
    traditional: "黑椒牛柳",
  },
  {
    chapter: "Beef & lamb",
    english: "Beef in oyster sauce",
    id: "beef-in-oyster-sauce",
    simplified: "蚝油牛肉",
    traditional: "蠔油牛肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Beef with broccoli",
    id: "beef-with-broccoli",
    simplified: "西兰花炒牛肉",
    traditional: "西蘭花炒牛肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Tomato beef brisket stew",
    id: "tomato-beef-brisket-stew",
    simplified: "番茄炖牛腩",
    traditional: "番茄燉牛腩",
  },
  {
    chapter: "Beef & lamb",
    english: "Beef and potato stew",
    id: "beef-and-potato-stew",
    simplified: "土豆炖牛肉",
    traditional: "土豆燉牛肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Beef brisket with daikon",
    id: "beef-brisket-with-daikon",
    simplified: "萝卜牛腩",
    traditional: "蘿蔔牛腩",
  },
  {
    chapter: "Beef & lamb",
    english: "Red-braised beef brisket",
    id: "red-braised-beef-brisket",
    simplified: "红烧牛腩",
    traditional: "紅燒牛腩",
  },
  {
    chapter: "Beef & lamb",
    english: "Scallion beef",
    id: "scallion-beef",
    simplified: "葱爆牛肉",
    traditional: "蔥爆牛肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Cumin beef",
    id: "cumin-beef",
    simplified: "孜然牛肉",
    traditional: "孜然牛肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Dry-fried shredded beef",
    id: "dry-fried-shredded-beef",
    simplified: "干煸牛肉丝",
    traditional: "乾煸牛肉絲",
  },
  {
    chapter: "Beef & lamb",
    english: "Beef with Hangzhou peppers",
    id: "beef-with-hangzhou-peppers",
    simplified: "杭椒牛柳",
    traditional: "杭椒牛柳",
  },
  {
    chapter: "Beef & lamb",
    english: "Sliced beef in sour broth",
    id: "sliced-beef-in-sour-broth",
    simplified: "酸汤肥牛",
    traditional: "酸湯肥牛",
  },
  {
    chapter: "Beef & lamb",
    english: "Sizzling beef",
    id: "sizzling-beef",
    simplified: "铁板牛肉",
    traditional: "鐵板牛肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Beef in shacha sauce",
    id: "beef-in-shacha-sauce",
    simplified: "沙茶牛肉",
    traditional: "沙茶牛肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Scallion lamb",
    id: "scallion-lamb",
    simplified: "葱爆羊肉",
    traditional: "蔥爆羊肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Cumin lamb",
    id: "cumin-lamb",
    simplified: "孜然羊肉",
    traditional: "孜然羊肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Hand-pulled boiled lamb",
    id: "hand-pulled-boiled-lamb",
    simplified: "手抓羊肉",
    traditional: "手抓羊肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Red-braised lamb",
    id: "red-braised-lamb",
    simplified: "红焖羊肉",
    traditional: "紅燜羊肉",
  },
  {
    chapter: "Beef & lamb",
    english: "Grilled lamb skewers",
    id: "grilled-lamb-skewers",
    simplified: "烤羊肉串",
    traditional: "烤羊肉串",
  },
  {
    chapter: "Beef & lamb",
    english: "Roast leg of lamb",
    id: "roast-leg-of-lamb",
    simplified: "烤羊腿",
    traditional: "烤羊腿",
  },
  {
    chapter: "Beef & lamb",
    english: "Whole roast lamb",
    id: "whole-roast-lamb",
    simplified: "烤全羊",
    traditional: "烤全羊",
  },
  {
    chapter: "Beef & lamb",
    english: "Beijing sweet glazed lamb",
    id: "beijing-sweet-glazed-lamb",
    simplified: "它似蜜",
    traditional: "它似蜜",
  },
  {
    chapter: "Beef & lamb",
    english: "Lamb spine stew",
    id: "lamb-spine-stew",
    simplified: "羊蝎子",
    traditional: "羊蠍子",
  },
  {
    chapter: "Poultry",
    english: "Kung pao chicken",
    id: "kung-pao-chicken",
    simplified: "宫保鸡丁",
    traditional: "宮保雞丁",
  },
  {
    chapter: "Poultry",
    english: "Chongqing chili chicken",
    id: "chongqing-chili-chicken",
    simplified: "辣子鸡",
    traditional: "辣子雞",
  },
  {
    chapter: "Poultry",
    english: "White-cut chicken",
    id: "white-cut-chicken",
    simplified: "白切鸡",
    traditional: "白切雞",
  },
  {
    chapter: "Poultry",
    english: "Salt-baked chicken",
    id: "salt-baked-chicken",
    simplified: "盐焗鸡",
    traditional: "鹽焗雞",
  },
  {
    chapter: "Poultry",
    english: "Soy sauce chicken",
    id: "soy-sauce-chicken",
    simplified: "豉油鸡",
    traditional: "豉油雞",
  },
  {
    chapter: "Poultry",
    english: "Three-cup chicken",
    id: "three-cup-chicken",
    simplified: "三杯鸡",
    traditional: "三杯雞",
  },
  {
    chapter: "Poultry",
    english: "Braised chicken with mushrooms",
    id: "braised-chicken-with-mushrooms",
    simplified: "黄焖鸡",
    traditional: "黃燜雞",
  },
  {
    chapter: "Poultry",
    english: "Xinjiang big-plate chicken",
    id: "xinjiang-big-plate-chicken",
    simplified: "大盘鸡",
    traditional: "大盤雞",
  },
  {
    chapter: "Poultry",
    english: "Beggar's chicken",
    id: "beggar-s-chicken",
    simplified: "叫花鸡",
    traditional: "叫花雞",
  },
  {
    chapter: "Poultry",
    english: "Dezhou braised chicken",
    id: "dezhou-braised-chicken",
    simplified: "德州扒鸡",
    traditional: "德州扒雞",
  },
  {
    chapter: "Poultry",
    english: "Daokou braised chicken",
    id: "daokou-braised-chicken",
    simplified: "道口烧鸡",
    traditional: "道口燒雞",
  },
  {
    chapter: "Poultry",
    english: "Fuliji braised chicken",
    id: "fuliji-braised-chicken",
    simplified: "符离集烧鸡",
    traditional: "符離集燒雞",
  },
  {
    chapter: "Poultry",
    english: "Wenchang chicken",
    id: "wenchang-chicken",
    simplified: "文昌鸡",
    traditional: "文昌雞",
  },
  {
    chapter: "Poultry",
    english: "Yunnan steam-pot chicken",
    id: "yunnan-steam-pot-chicken",
    simplified: "汽锅鸡",
    traditional: "汽鍋雞",
  },
  {
    chapter: "Poultry",
    english: "Scallion oil chicken",
    id: "scallion-oil-chicken",
    simplified: "葱油鸡",
    traditional: "蔥油雞",
  },
  {
    chapter: "Poultry",
    english: "Silky chicken with mushrooms",
    id: "silky-chicken-with-mushrooms",
    simplified: "香菇滑鸡",
    traditional: "香菇滑雞",
  },
  {
    chapter: "Poultry",
    english: "Cola chicken wings",
    id: "cola-chicken-wings",
    simplified: "可乐鸡翅",
    traditional: "可樂雞翅",
  },
  {
    chapter: "Poultry",
    english: "Wine-braised chicken wings",
    id: "wine-braised-chicken-wings",
    simplified: "贵妃鸡翅",
    traditional: "貴妃雞翅",
  },
  {
    chapter: "Poultry",
    english: "Chicken feet in black bean sauce",
    id: "chicken-feet-in-black-bean-sauce",
    simplified: "豉汁凤爪",
    traditional: "豉汁鳳爪",
  },
  {
    chapter: "Poultry",
    english: "Peking duck",
    id: "peking-duck",
    simplified: "北京烤鸭",
    traditional: "北京烤鴨",
  },
  {
    chapter: "Poultry",
    english: "Nanjing salted duck",
    id: "nanjing-salted-duck",
    simplified: "南京盐水鸭",
    traditional: "南京鹽水鴨",
  },
  {
    chapter: "Poultry",
    english: "Tea-smoked duck",
    id: "tea-smoked-duck",
    simplified: "樟茶鸭",
    traditional: "樟茶鴨",
  },
  {
    chapter: "Poultry",
    english: "Beer-braised duck",
    id: "beer-braised-duck",
    simplified: "啤酒鸭",
    traditional: "啤酒鴨",
  },
  {
    chapter: "Poultry",
    english: "Ginger duck",
    id: "ginger-duck",
    simplified: "姜母鸭",
    traditional: "薑母鴨",
  },
  {
    chapter: "Poultry",
    english: "Crispy roast squab",
    id: "crispy-roast-squab",
    simplified: "红烧乳鸽",
    traditional: "紅燒乳鴿",
  },
  {
    chapter: "Fish",
    english: "Steamed sea bass",
    id: "steamed-sea-bass",
    simplified: "清蒸鲈鱼",
    traditional: "清蒸鱸魚",
  },
  {
    chapter: "Fish",
    english: "Steamed grouper",
    id: "steamed-grouper",
    simplified: "清蒸石斑鱼",
    traditional: "清蒸石斑魚",
  },
  {
    chapter: "Fish",
    english: "Squirrel-shaped mandarin fish",
    id: "squirrel-shaped-mandarin-fish",
    simplified: "松鼠桂鱼",
    traditional: "松鼠桂魚",
  },
  {
    chapter: "Fish",
    english: "Sweet and sour carp",
    id: "sweet-and-sour-carp",
    simplified: "糖醋鲤鱼",
    traditional: "糖醋鯉魚",
  },
  {
    chapter: "Fish",
    english: "West Lake vinegar fish",
    id: "west-lake-vinegar-fish",
    simplified: "西湖醋鱼",
    traditional: "西湖醋魚",
  },
  {
    chapter: "Fish",
    english: "Fish with pickled mustard greens",
    id: "fish-with-pickled-mustard-greens",
    simplified: "酸菜鱼",
    traditional: "酸菜魚",
  },
  {
    chapter: "Fish",
    english: "Sichuan chili-poached fish",
    id: "sichuan-chili-poached-fish",
    simplified: "水煮鱼",
    traditional: "水煮魚",
  },
  {
    chapter: "Fish",
    english: "Fish head with chopped chilies",
    id: "fish-head-with-chopped-chilies",
    simplified: "剁椒鱼头",
    traditional: "剁椒魚頭",
  },
  {
    chapter: "Fish",
    english: "Fish in chili bean sauce",
    id: "fish-in-chili-bean-sauce",
    simplified: "豆瓣鱼",
    traditional: "豆瓣魚",
  },
  {
    chapter: "Fish",
    english: "Braised ribbonfish",
    id: "braised-ribbonfish",
    simplified: "红烧带鱼",
    traditional: "紅燒帶魚",
  },
  {
    chapter: "Fish",
    english: "Fried ribbonfish",
    id: "fried-ribbonfish",
    simplified: "干炸带鱼",
    traditional: "幹炸帶魚",
  },
  {
    chapter: "Fish",
    english: "Pan-fried yellow croaker",
    id: "pan-fried-yellow-croaker",
    simplified: "香煎黄花鱼",
    traditional: "香煎黃花魚",
  },
  {
    chapter: "Fish",
    english: "Steamed turbot",
    id: "steamed-turbot",
    simplified: "清蒸多宝鱼",
    traditional: "清蒸多寶魚",
  },
  {
    chapter: "Fish",
    english: "Fish with scallion oil",
    id: "fish-with-scallion-oil",
    simplified: "葱油鱼",
    traditional: "蔥油魚",
  },
  {
    chapter: "Fish",
    english: "Fish slices in rice wine lees sauce",
    id: "fish-slices-in-rice-wine-lees-sauce",
    simplified: "糟溜鱼片",
    traditional: "糟溜魚片",
  },
  {
    chapter: "Fish",
    english: "Chrysanthemum-cut fish",
    id: "chrysanthemum-cut-fish",
    simplified: "菊花鱼",
    traditional: "菊花魚",
  },
  {
    chapter: "Fish",
    english: "Shanghai smoked-style fish",
    id: "shanghai-smoked-style-fish",
    simplified: "熏鱼",
    traditional: "燻魚",
  },
  {
    chapter: "Fish",
    english: "Anhui fermented mandarin fish",
    id: "anhui-fermented-mandarin-fish",
    simplified: "臭鳜鱼",
    traditional: "臭鱖魚",
  },
  {
    chapter: "Fish",
    english: "Braised eel segments",
    id: "braised-eel-segments",
    simplified: "红烧鳝段",
    traditional: "紅燒鱔段",
  },
  {
    chapter: "Fish",
    english: "Sizzling eel shreds",
    id: "sizzling-eel-shreds",
    simplified: "响油鳝糊",
    traditional: "響油鱔糊",
  },
  {
    chapter: "Fish",
    english: "Dry-fried eel shreds",
    id: "dry-fried-eel-shreds",
    simplified: "干煸鳝丝",
    traditional: "乾煸鱔絲",
  },
  {
    chapter: "Fish",
    english: "Yellow-braised fish",
    id: "yellow-braised-fish",
    simplified: "黄焖鱼",
    traditional: "黃燜魚",
  },
  {
    chapter: "Fish",
    english: "Dace with black beans",
    id: "dace-with-black-beans",
    simplified: "豆豉鲮鱼",
    traditional: "豆豉鯪魚",
  },
  {
    chapter: "Fish",
    english: "Grilled fish in garlic sauce",
    id: "grilled-fish-in-garlic-sauce",
    simplified: "鱼香烤鱼",
    traditional: "魚香烤魚",
  },
  {
    chapter: "Fish",
    english: "Mala grilled fish",
    id: "mala-grilled-fish",
    simplified: "麻辣烤鱼",
    traditional: "麻辣烤魚",
  },
  {
    chapter: "Seafood",
    english: "Oil-braised prawns",
    id: "oil-braised-prawns",
    simplified: "油焖大虾",
    traditional: "油燜大蝦",
  },
  {
    chapter: "Seafood",
    english: "Poached shrimp",
    id: "poached-shrimp",
    simplified: "白灼虾",
    traditional: "白灼蝦",
  },
  {
    chapter: "Seafood",
    english: "Salt and pepper shrimp",
    id: "salt-and-pepper-shrimp",
    simplified: "椒盐虾",
    traditional: "椒鹽蝦",
  },
  {
    chapter: "Seafood",
    english: "Garlic shrimp with glass noodles",
    id: "garlic-shrimp-with-glass-noodles",
    simplified: "蒜蓉粉丝蒸虾",
    traditional: "蒜蓉粉絲蒸蝦",
  },
  {
    chapter: "Seafood",
    english: "Longjing tea shrimp",
    id: "longjing-tea-shrimp",
    simplified: "龙井虾仁",
    traditional: "龍井蝦仁",
  },
  {
    chapter: "Seafood",
    english: "Kung pao shrimp",
    id: "kung-pao-shrimp",
    simplified: "宫保虾球",
    traditional: "宮保蝦球",
  },
  {
    chapter: "Seafood",
    english: "Dry-braised shrimp",
    id: "dry-braised-shrimp",
    simplified: "干烧虾仁",
    traditional: "乾燒蝦仁",
  },
  {
    chapter: "Seafood",
    english: "Stir-fried shrimp",
    id: "stir-fried-shrimp",
    simplified: "清炒虾仁",
    traditional: "清炒蝦仁",
  },
  {
    chapter: "Seafood",
    english: "Typhoon shelter crab",
    id: "typhoon-shelter-crab",
    simplified: "避风塘炒蟹",
    traditional: "避風塘炒蟹",
  },
  {
    chapter: "Seafood",
    english: "Crab with ginger and scallions",
    id: "crab-with-ginger-and-scallions",
    simplified: "姜葱炒蟹",
    traditional: "姜蔥炒蟹",
  },
  {
    chapter: "Seafood",
    english: "Steamed hairy crab",
    id: "steamed-hairy-crab",
    simplified: "清蒸大闸蟹",
    traditional: "清蒸大閘蟹",
  },
  {
    chapter: "Seafood",
    english: "Spicy crab",
    id: "spicy-crab",
    simplified: "香辣蟹",
    traditional: "香辣蟹",
  },
  {
    chapter: "Seafood",
    english: "Lobster with ginger and scallions",
    id: "lobster-with-ginger-and-scallions",
    simplified: "葱姜龙虾",
    traditional: "蔥姜龍蝦",
  },
  {
    chapter: "Seafood",
    english: "Garlic scallops with glass noodles",
    id: "garlic-scallops-with-glass-noodles",
    simplified: "蒜蓉粉丝蒸扇贝",
    traditional: "蒜蓉粉絲蒸扇貝",
  },
  {
    chapter: "Seafood",
    english: "Scallops in black bean sauce",
    id: "scallops-in-black-bean-sauce",
    simplified: "豉汁蒸扇贝",
    traditional: "豉汁蒸扇貝",
  },
  {
    chapter: "Seafood",
    english: "Stir-fried clams",
    id: "stir-fried-clams",
    simplified: "爆炒花蛤",
    traditional: "爆炒花蛤",
  },
  {
    chapter: "Seafood",
    english: "Spicy razor clams",
    id: "spicy-razor-clams",
    simplified: "辣炒蛏子",
    traditional: "辣炒蟶子",
  },
  {
    chapter: "Seafood",
    english: "Clams with peppers and black beans",
    id: "clams-with-peppers-and-black-beans",
    simplified: "豉椒炒蚬",
    traditional: "豉椒炒蜆",
  },
  {
    chapter: "Seafood",
    english: "Steamed oysters",
    id: "steamed-oysters",
    simplified: "清蒸生蚝",
    traditional: "清蒸生蠔",
  },
  {
    chapter: "Seafood",
    english: "Salt and pepper squid",
    id: "salt-and-pepper-squid",
    simplified: "椒盐鱿鱼",
    traditional: "椒鹽魷魚",
  },
  {
    chapter: "Seafood",
    english: "Sizzling squid",
    id: "sizzling-squid",
    simplified: "铁板鱿鱼",
    traditional: "鐵板魷魚",
  },
  {
    chapter: "Seafood",
    english: "Squid with Chinese chives",
    id: "squid-with-chinese-chives",
    simplified: "韭菜炒鱿鱼",
    traditional: "韭菜炒魷魚",
  },
  {
    chapter: "Seafood",
    english: "Braised sea cucumber with scallions",
    id: "braised-sea-cucumber-with-scallions",
    simplified: "葱烧海参",
    traditional: "蔥燒海蔘",
  },
  {
    chapter: "Seafood",
    english: "Braised abalone",
    id: "braised-abalone",
    simplified: "红烧鲍鱼",
    traditional: "紅燒鮑魚",
  },
  {
    chapter: "Seafood",
    english: "Garlic steamed mussels",
    id: "garlic-steamed-mussels",
    simplified: "蒜蓉蒸青口",
    traditional: "蒜蓉蒸青口",
  },
  {
    chapter: "Tofu & eggs",
    english: "Mapo tofu",
    id: "mapo-tofu",
    simplified: "麻婆豆腐",
    traditional: "麻婆豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Homestyle tofu",
    id: "homestyle-tofu",
    simplified: "家常豆腐",
    traditional: "家常豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Red-braised tofu",
    id: "red-braised-tofu",
    simplified: "红烧豆腐",
    traditional: "紅燒豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Shandong pan-fried braised tofu",
    id: "shandong-pan-fried-braised-tofu",
    simplified: "锅塌豆腐",
    traditional: "鍋塌豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Wensi shredded tofu soup",
    id: "wensi-shredded-tofu-soup",
    simplified: "文思豆腐",
    traditional: "文思豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Eight-treasure tofu",
    id: "eight-treasure-tofu",
    simplified: "八珍豆腐",
    traditional: "八珍豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Crispy tofu",
    id: "crispy-tofu",
    simplified: "脆皮豆腐",
    traditional: "脆皮豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Sizzling tofu",
    id: "sizzling-tofu",
    simplified: "铁板豆腐",
    traditional: "鐵板豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Hakka stuffed tofu",
    id: "hakka-stuffed-tofu",
    simplified: "客家酿豆腐",
    traditional: "客家釀豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Tofu with scallions",
    id: "tofu-with-scallions",
    simplified: "小葱拌豆腐",
    traditional: "小蔥拌豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Tofu with Chinese toon",
    id: "tofu-with-chinese-toon",
    simplified: "香椿拌豆腐",
    traditional: "香椿拌豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Dry-pot layered tofu",
    id: "dry-pot-layered-tofu",
    simplified: "干锅千页豆腐",
    traditional: "乾鍋千頁豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Tofu sheets with green chilies",
    id: "tofu-sheets-with-green-chilies",
    simplified: "尖椒干豆腐",
    traditional: "尖椒幹豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Celery with pressed tofu",
    id: "celery-with-pressed-tofu",
    simplified: "芹菜炒香干",
    traditional: "芹菜炒香乾",
  },
  {
    chapter: "Tofu & eggs",
    english: "Chinese chives with pressed tofu",
    id: "chinese-chives-with-pressed-tofu",
    simplified: "韭菜炒豆干",
    traditional: "韭菜炒豆乾",
  },
  {
    chapter: "Tofu & eggs",
    english: "Edamame with stinky tofu",
    id: "edamame-with-stinky-tofu",
    simplified: "毛豆炒臭豆腐",
    traditional: "毛豆炒臭豆腐",
  },
  {
    chapter: "Tofu & eggs",
    english: "Tomato and eggs",
    id: "tomato-eggs",
    simplified: "番茄炒蛋",
    traditional: "番茄炒蛋",
  },
  {
    chapter: "Tofu & eggs",
    english: "Chinese chives and eggs",
    id: "chinese-chives-and-eggs",
    simplified: "韭菜炒鸡蛋",
    traditional: "韭菜炒雞蛋",
  },
  {
    chapter: "Tofu & eggs",
    english: "Shrimp and eggs",
    id: "shrimp-and-eggs",
    simplified: "虾仁炒蛋",
    traditional: "蝦仁炒蛋",
  },
  {
    chapter: "Tofu & eggs",
    english: "Whitebait and eggs",
    id: "whitebait-and-eggs",
    simplified: "银鱼炒蛋",
    traditional: "銀魚炒蛋",
  },
  {
    chapter: "Tofu & eggs",
    english: "Bitter melon and eggs",
    id: "bitter-melon-and-eggs",
    simplified: "苦瓜炒蛋",
    traditional: "苦瓜炒蛋",
  },
  {
    chapter: "Tofu & eggs",
    english: "Steamed egg custard",
    id: "steamed-egg-custard",
    simplified: "蒸水蛋",
    traditional: "蒸水蛋",
  },
  {
    chapter: "Tofu & eggs",
    english: "Steamed eggs with clams",
    id: "steamed-eggs-with-clams",
    simplified: "蛤蜊蒸蛋",
    traditional: "蛤蜊蒸蛋",
  },
  {
    chapter: "Tofu & eggs",
    english: "Tea eggs",
    id: "tea-eggs",
    simplified: "茶叶蛋",
    traditional: "茶葉蛋",
  },
  {
    chapter: "Tofu & eggs",
    english: "Tiger-skin eggs",
    id: "tiger-skin-eggs",
    simplified: "虎皮蛋",
    traditional: "虎皮蛋",
  },
  {
    chapter: "Vegetables",
    english: "Stir-fried bok choy",
    id: "stir-fried-bok-choy",
    simplified: "清炒小白菜",
    traditional: "清炒小白菜",
  },
  {
    chapter: "Vegetables",
    english: "Garlic broccoli",
    id: "garlic-broccoli",
    simplified: "蒜蓉西兰花",
    traditional: "蒜蓉西蘭花",
  },
  {
    chapter: "Vegetables",
    english: "Lettuce in oyster sauce",
    id: "lettuce-in-oyster-sauce",
    simplified: "蚝油生菜",
    traditional: "蠔油生菜",
  },
  {
    chapter: "Vegetables",
    english: "Blanched choy sum",
    id: "blanched-choy-sum",
    simplified: "白灼菜心",
    traditional: "白灼菜心",
  },
  {
    chapter: "Vegetables",
    english: "Garlic water spinach",
    id: "garlic-water-spinach",
    simplified: "蒜蓉空心菜",
    traditional: "蒜蓉空心菜",
  },
  {
    chapter: "Vegetables",
    english: "Stir-fried pea shoots",
    id: "stir-fried-pea-shoots",
    simplified: "清炒豆苗",
    traditional: "清炒豆苗",
  },
  {
    chapter: "Vegetables",
    english: "Baby cabbage in broth",
    id: "baby-cabbage-in-broth",
    simplified: "上汤娃娃菜",
    traditional: "上湯娃娃菜",
  },
  {
    chapter: "Vegetables",
    english: "Hand-torn cabbage",
    id: "hand-torn-cabbage",
    simplified: "手撕包菜",
    traditional: "手撕包菜",
  },
  {
    chapter: "Vegetables",
    english: "Cabbage with vinegar sauce",
    id: "cabbage-with-vinegar-sauce",
    simplified: "醋溜白菜",
    traditional: "醋溜白菜",
  },
  {
    chapter: "Vegetables",
    english: "Dry-fried green beans",
    id: "dry-fried-green-beans",
    simplified: "干煸四季豆",
    traditional: "乾煸四季豆",
  },
  {
    chapter: "Vegetables",
    english: "Blistered green peppers",
    id: "blistered-green-peppers",
    simplified: "虎皮青椒",
    traditional: "虎皮青椒",
  },
  {
    chapter: "Vegetables",
    english: "Eggplant, potato and pepper stir-fry",
    id: "eggplant-potato-and-pepper-stir-fry",
    simplified: "地三鲜",
    traditional: "地三鮮",
  },
  {
    chapter: "Vegetables",
    english: "Eggplant in garlic sauce",
    id: "eggplant-in-garlic-sauce",
    simplified: "鱼香茄子",
    traditional: "魚香茄子",
  },
  {
    chapter: "Vegetables",
    english: "Claypot eggplant",
    id: "claypot-eggplant",
    simplified: "茄子煲",
    traditional: "茄子煲",
  },
  {
    chapter: "Vegetables",
    english: "Hot and sour shredded potatoes",
    id: "hot-and-sour-shredded-potatoes",
    simplified: "酸辣土豆丝",
    traditional: "酸辣土豆絲",
  },
  {
    chapter: "Vegetables",
    english: "Vinegar shredded potatoes",
    id: "vinegar-shredded-potatoes",
    simplified: "醋溜土豆丝",
    traditional: "醋溜土豆絲",
  },
  {
    chapter: "Vegetables",
    english: "Candied sweet potatoes",
    id: "candied-sweet-potatoes",
    simplified: "拔丝地瓜",
    traditional: "拔絲地瓜",
  },
  {
    chapter: "Vegetables",
    english: "Dry-pot cauliflower",
    id: "dry-pot-cauliflower",
    simplified: "干锅花菜",
    traditional: "乾鍋花菜",
  },
  {
    chapter: "Vegetables",
    english: "Stir-fried celtuce",
    id: "stir-fried-celtuce",
    simplified: "清炒莴笋",
    traditional: "清炒萵筍",
  },
  {
    chapter: "Vegetables",
    english: "Oil-braised spring bamboo shoots",
    id: "oil-braised-spring-bamboo-shoots",
    simplified: "油焖春笋",
    traditional: "油燜春筍",
  },
  {
    chapter: "Vegetables",
    english: "Bok choy with shiitake mushrooms",
    id: "bok-choy-with-shiitake-mushrooms",
    simplified: "香菇青菜",
    traditional: "香菇青菜",
  },
  {
    chapter: "Vegetables",
    english: "Buddha's delight",
    id: "buddha-s-delight",
    simplified: "罗汉斋",
    traditional: "羅漢齋",
  },
  {
    chapter: "Vegetables",
    english: "Lotus pond vegetable stir-fry",
    id: "lotus-pond-vegetable-stir-fry",
    simplified: "荷塘小炒",
    traditional: "荷塘小炒",
  },
  {
    chapter: "Vegetables",
    english: "Three-vegetable stir-fry",
    id: "three-vegetable-stir-fry",
    simplified: "素炒三鲜",
    traditional: "素炒三鮮",
  },
  {
    chapter: "Vegetables",
    english: "Pumpkin with salted egg yolk",
    id: "pumpkin-with-salted-egg-yolk",
    simplified: "咸蛋黄焗南瓜",
    traditional: "鹹蛋黃焗南瓜",
  },
  {
    chapter: "Soups",
    english: "Hot and sour soup",
    id: "hot-and-sour-soup",
    simplified: "酸辣汤",
    traditional: "酸辣湯",
  },
  {
    chapter: "Soups",
    english: "Egg drop soup",
    id: "egg-drop-soup",
    simplified: "蛋花汤",
    traditional: "蛋花湯",
  },
  {
    chapter: "Soups",
    english: "Seaweed and egg soup",
    id: "seaweed-and-egg-soup",
    simplified: "紫菜蛋花汤",
    traditional: "紫菜蛋花湯",
  },
  {
    chapter: "Soups",
    english: "Tomato and egg soup",
    id: "tomato-and-egg-soup",
    simplified: "西红柿蛋汤",
    traditional: "西紅柿蛋湯",
  },
  {
    chapter: "Soups",
    english: "Winter melon and pork rib soup",
    id: "winter-melon-and-pork-rib-soup",
    simplified: "冬瓜排骨汤",
    traditional: "冬瓜排骨湯",
  },
  {
    chapter: "Soups",
    english: "Lotus root and pork rib soup",
    id: "lotus-root-and-pork-rib-soup",
    simplified: "莲藕排骨汤",
    traditional: "蓮藕排骨湯",
  },
  {
    chapter: "Soups",
    english: "Corn and pork rib soup",
    id: "corn-and-pork-rib-soup",
    simplified: "玉米排骨汤",
    traditional: "玉米排骨湯",
  },
  {
    chapter: "Soups",
    english: "Daikon and pork rib soup",
    id: "daikon-and-pork-rib-soup",
    simplified: "萝卜排骨汤",
    traditional: "蘿蔔排骨湯",
  },
  {
    chapter: "Soups",
    english: "Kelp and pork rib soup",
    id: "kelp-and-pork-rib-soup",
    simplified: "海带排骨汤",
    traditional: "海帶排骨湯",
  },
  {
    chapter: "Soups",
    english: "Pork stomach and chicken soup",
    id: "pork-stomach-and-chicken-soup",
    simplified: "猪肚鸡汤",
    traditional: "豬肚雞湯",
  },
  {
    chapter: "Soups",
    english: "Peppery pork stomach soup",
    id: "peppery-pork-stomach-soup",
    simplified: "胡椒猪肚汤",
    traditional: "胡椒豬肚湯",
  },
  {
    chapter: "Soups",
    english: "Slow-simmered duck soup",
    id: "slow-simmered-duck-soup",
    simplified: "老鸭汤",
    traditional: "老鴨湯",
  },
  {
    chapter: "Soups",
    english: "Duck soup with pickled radish",
    id: "duck-soup-with-pickled-radish",
    simplified: "酸萝卜老鸭汤",
    traditional: "酸蘿蔔老鴨湯",
  },
  {
    chapter: "Soups",
    english: "Duck blood and glass noodle soup",
    id: "duck-blood-and-glass-noodle-soup",
    simplified: "鸭血粉丝汤",
    traditional: "鴨血粉絲湯",
  },
  {
    chapter: "Soups",
    english: "West Lake minced beef soup",
    id: "west-lake-minced-beef-soup",
    simplified: "西湖牛肉羹",
    traditional: "西湖牛肉羹",
  },
  {
    chapter: "Soups",
    english: "Sister Song's fish soup",
    id: "sister-song-s-fish-soup",
    simplified: "宋嫂鱼羹",
    traditional: "宋嫂魚羹",
  },
  {
    chapter: "Soups",
    english: "Fish head and tofu soup",
    id: "fish-head-and-tofu-soup",
    simplified: "鱼头豆腐汤",
    traditional: "魚頭豆腐湯",
  },
  {
    chapter: "Soups",
    english: "Crucian carp and tofu soup",
    id: "crucian-carp-and-tofu-soup",
    simplified: "鲫鱼豆腐汤",
    traditional: "鯽魚豆腐湯",
  },
  {
    chapter: "Soups",
    english: "Lamb soup",
    id: "lamb-soup",
    simplified: "羊肉汤",
    traditional: "羊肉湯",
  },
  {
    chapter: "Soups",
    english: "Beef ball soup",
    id: "beef-ball-soup",
    simplified: "牛肉丸汤",
    traditional: "牛肉丸湯",
  },
  {
    chapter: "Soups",
    english: "Fish ball soup",
    id: "fish-ball-soup",
    simplified: "鱼丸汤",
    traditional: "魚丸湯",
  },
  {
    chapter: "Soups",
    english: "Buddha jumps over the wall",
    id: "buddha-jumps-over-the-wall",
    simplified: "佛跳墙",
    traditional: "佛跳牆",
  },
  {
    chapter: "Soups",
    english: "Henan pepper soup",
    id: "henan-pepper-soup",
    simplified: "胡辣汤",
    traditional: "胡辣湯",
  },
  {
    chapter: "Soups",
    english: "Three-delicacy soup",
    id: "three-delicacy-soup",
    simplified: "三鲜汤",
    traditional: "三鮮湯",
  },
  {
    chapter: "Soups",
    english: "Bamboo fungus and chicken soup",
    id: "bamboo-fungus-and-chicken-soup",
    simplified: "竹荪鸡汤",
    traditional: "竹蓀雞湯",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Hot pot",
    id: "hot-pot",
    simplified: "火锅",
    traditional: "火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Sichuan mala hot pot",
    id: "sichuan-mala-hot-pot",
    simplified: "四川麻辣火锅",
    traditional: "四川麻辣火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Chongqing beef-tallow hot pot",
    id: "chongqing-beef-tallow-hot-pot",
    simplified: "重庆牛油火锅",
    traditional: "重慶牛油火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Beijing lamb hot pot",
    id: "beijing-lamb-hot-pot",
    simplified: "北京涮羊肉",
    traditional: "北京涮羊肉",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Chaoshan beef hot pot",
    id: "chaoshan-beef-hot-pot",
    simplified: "潮汕牛肉火锅",
    traditional: "潮汕牛肉火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Pickled cabbage and pork hot pot",
    id: "pickled-cabbage-and-pork-hot-pot",
    simplified: "酸菜白肉锅",
    traditional: "酸菜白肉鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Pork stomach and chicken hot pot",
    id: "pork-stomach-and-chicken-hot-pot",
    simplified: "猪肚鸡火锅",
    traditional: "豬肚雞火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Coconut chicken hot pot",
    id: "coconut-chicken-hot-pot",
    simplified: "椰子鸡火锅",
    traditional: "椰子雞火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Yunnan mushroom hot pot",
    id: "yunnan-mushroom-hot-pot",
    simplified: "云南菌子火锅",
    traditional: "雲南菌子火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Sour fish hot pot",
    id: "sour-fish-hot-pot",
    simplified: "酸汤鱼火锅",
    traditional: "酸湯魚火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Tomato hot pot",
    id: "tomato-hot-pot",
    simplified: "番茄火锅",
    traditional: "番茄火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Clear broth hot pot",
    id: "clear-broth-hot-pot",
    simplified: "清汤火锅",
    traditional: "清湯火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Seafood hot pot",
    id: "seafood-hot-pot",
    simplified: "海鲜火锅",
    traditional: "海鮮火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Lamb hot pot",
    id: "lamb-hot-pot",
    simplified: "羊肉火锅",
    traditional: "羊肉火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Chrysanthemum hot pot",
    id: "chrysanthemum-hot-pot",
    simplified: "菊花火锅",
    traditional: "菊花火鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Sichuan hot pot skewers",
    id: "sichuan-hot-pot-skewers",
    simplified: "串串香",
    traditional: "串串香",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Mala soup bowl",
    id: "mala-soup-bowl",
    simplified: "麻辣烫",
    traditional: "麻辣燙",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Chengdu hot pot bowl",
    id: "chengdu-hot-pot-bowl",
    simplified: "冒菜",
    traditional: "冒菜",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Cold skewers in chili broth",
    id: "cold-skewers-in-chili-broth",
    simplified: "钵钵鸡",
    traditional: "鉢鉢雞",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Mala dry pot",
    id: "mala-dry-pot",
    simplified: "麻辣香锅",
    traditional: "麻辣香鍋",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Dry-pot pork intestines",
    id: "dry-pot-pork-intestines",
    simplified: "干锅肥肠",
    traditional: "乾鍋肥腸",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Dry-pot bullfrog",
    id: "dry-pot-bullfrog",
    simplified: "干锅牛蛙",
    traditional: "乾鍋牛蛙",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Dry-pot shrimp",
    id: "dry-pot-shrimp",
    simplified: "干锅虾",
    traditional: "乾鍋蝦",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Dry-pot tea tree mushrooms",
    id: "dry-pot-tea-tree-mushrooms",
    simplified: "干锅茶树菇",
    traditional: "乾鍋茶樹菇",
  },
  {
    chapter: "Hot pot & dry pot",
    english: "Dry-pot potato slices",
    id: "dry-pot-potato-slices",
    simplified: "干锅土豆片",
    traditional: "乾鍋土豆片",
  },
  {
    chapter: "Desserts",
    english: "Sweet rice balls",
    id: "sweet-rice-balls",
    simplified: "汤圆",
    traditional: "湯圓",
  },
  {
    chapter: "Desserts",
    english: "Egg tarts",
    id: "egg-tarts",
    simplified: "蛋挞",
    traditional: "蛋撻",
  },
  {
    chapter: "Desserts",
    english: "Mooncakes",
    id: "mooncakes",
    simplified: "月饼",
    traditional: "月餅",
  },
  {
    chapter: "Desserts",
    english: "Black sesame rice balls",
    id: "black-sesame-rice-balls",
    simplified: "芝麻汤圆",
    traditional: "芝麻湯圓",
  },
  {
    chapter: "Desserts",
    english: "Peanut rice balls",
    id: "peanut-rice-balls",
    simplified: "花生汤圆",
    traditional: "花生湯圓",
  },
  {
    chapter: "Desserts",
    english: "Rice balls in sweet fermented rice",
    id: "rice-balls-in-sweet-fermented-rice",
    simplified: "酒酿圆子",
    traditional: "酒釀圓子",
  },
  {
    chapter: "Desserts",
    english: "Osmanthus sticky rice lotus root",
    id: "osmanthus-sticky-rice-lotus-root",
    simplified: "桂花糖藕",
    traditional: "桂花糖藕",
  },
  {
    chapter: "Desserts",
    english: "Osmanthus cakes",
    id: "osmanthus-cakes",
    simplified: "桂花糕",
    traditional: "桂花糕",
  },
  {
    chapter: "Desserts",
    english: "Red bean dessert soup",
    id: "red-bean-dessert-soup",
    simplified: "红豆沙",
    traditional: "紅豆沙",
  },
  {
    chapter: "Desserts",
    english: "Mung bean dessert soup",
    id: "mung-bean-dessert-soup",
    simplified: "绿豆沙",
    traditional: "綠豆沙",
  },
  {
    chapter: "Desserts",
    english: "Black sesame soup",
    id: "black-sesame-soup",
    simplified: "芝麻糊",
    traditional: "芝麻糊",
  },
  {
    chapter: "Desserts",
    english: "Almond dessert soup",
    id: "almond-dessert-soup",
    simplified: "杏仁糊",
    traditional: "杏仁糊",
  },
  {
    chapter: "Desserts",
    english: "Peanut dessert soup",
    id: "peanut-dessert-soup",
    simplified: "花生糊",
    traditional: "花生糊",
  },
  {
    chapter: "Desserts",
    english: "Walnut dessert soup",
    id: "walnut-dessert-soup",
    simplified: "核桃糊",
    traditional: "核桃糊",
  },
  {
    chapter: "Desserts",
    english: "Snow fungus and lotus seed soup",
    id: "snow-fungus-and-lotus-seed-soup",
    simplified: "银耳莲子羹",
    traditional: "銀耳蓮子羹",
  },
  {
    chapter: "Desserts",
    english: "Peach gum dessert soup",
    id: "peach-gum-dessert-soup",
    simplified: "桃胶羹",
    traditional: "桃膠羹",
  },
  {
    chapter: "Desserts",
    english: "Double-skin milk pudding",
    id: "double-skin-milk-pudding",
    simplified: "双皮奶",
    traditional: "雙皮奶",
  },
  {
    chapter: "Desserts",
    english: "Ginger milk curd",
    id: "ginger-milk-curd",
    simplified: "姜撞奶",
    traditional: "姜撞奶",
  },
  {
    chapter: "Desserts",
    english: "Mango pomelo sago",
    id: "mango-pomelo-sago",
    simplified: "杨枝甘露",
    traditional: "楊枝甘露",
  },
  {
    chapter: "Desserts",
    english: "Mango pudding",
    id: "mango-pudding",
    simplified: "芒果布丁",
    traditional: "芒果布丁",
  },
  {
    chapter: "Desserts",
    english: "Herbal jelly",
    id: "herbal-jelly",
    simplified: "龟苓膏",
    traditional: "龜苓膏",
  },
  {
    chapter: "Desserts",
    english: "Soft tofu pudding",
    id: "soft-tofu-pudding",
    simplified: "豆花",
    traditional: "豆花",
  },
  {
    chapter: "Desserts",
    english: "Sichuan ice jelly",
    id: "sichuan-ice-jelly",
    simplified: "冰粉",
    traditional: "冰粉",
  },
  {
    chapter: "Desserts",
    english: "Candied hawthorn skewers",
    id: "candied-hawthorn-skewers",
    simplified: "冰糖葫芦",
    traditional: "冰糖葫蘆",
  },
  {
    chapter: "Desserts",
    english: "Soybean-coated sticky rice rolls",
    id: "soybean-coated-sticky-rice-rolls",
    simplified: "驴打滚",
    traditional: "驢打滾",
  },
];
